export default __webpack_public_path__ + "static/media/BUSDicon.d4694154.png";